import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;
const fileUrl = process.env.REACT_APP_FILE_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("transocean_token");
    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// list customer payments

export const getOtherIncomes = async () => {
  try {
    const response = await axiosInstance.post("/getOtherIncomes");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getDeposits = async (data) => {
  try {
    const response = await axiosInstance.post("/getDeposits", data);
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getPrepaidExpenses = async (data) => {
  try {
    const response = await axiosInstance.post("/getPrepaidExpenses", data);
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getPayables = async (data) => {
  try {
    const response = await axiosInstance.post("/getPayables", data);
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getCashAssets = async (data) => {
  try {
    const response = await axiosInstance.post("/getCashAssets", data);
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getAllPayableItems = async (data) => {
  try {
    const response = await axiosInstance.post("/getAllPayableItems");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getProfitAndLossWithdrawals = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/getProfitAndLossWithdrawals",
      data,
    );
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getBankCharges = async () => {
  try {
    const response = await axiosInstance.post("/getBankCharges");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getTaxDetails = async () => {
  try {
    const response = await axiosInstance.post("/getTaxDetails");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getAssets = async () => {
  try {
    const response = await axiosInstance.post("/getAssets");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getAssetValues = async () => {
  try {
    const response = await axiosInstance.post("/getAssetValues");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getSales = async () => {
  try {
    const response = await axiosInstance.post("/getSales");
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getCapitals = async (data) => {
  try {
    const response = await axiosInstance.post("/getCapitals", data);
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};
export const getGratuities = async (data) => {
  try {
    const response = await axiosInstance.post("/getGratuities", data);
    return response.data;
  } catch (error) {
    console.log("Error in payment", error);
  }
};

export const saveOtherIncome = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveOtherIncome", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveDeposit = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveDeposit", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const savePrepaidExpense = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      "/savePrepaidExpense",
      paymentData,
    );
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const savePayable = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/savePayable", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveCashAsset = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveCashAsset", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveCapital = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveCapital", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveGratuity = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveGratuity", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveProfitAndLossWithdrawal = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      "/saveProfitAndLossWithdrawal",
      paymentData,
    );
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveBankCharge = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveBankCharge", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveTax = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveTax", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveAsset = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveAsset", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveAssetValue = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveAssetValue", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const saveSale = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/saveSale", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editOtherIncome = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editOtherIncome", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editDeposit = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editDeposit", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editPrepaidExpense = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      "/editPrepaidExpense",
      paymentData,
    );
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editPayable = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editPayable", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editCashAsset = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editCashAsset", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editCapital = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editCapital", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editGratuity = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editGratuity", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editProfitAndLossWithdrawal = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      "/editProfitAndLossWithdrawal",
      paymentData,
    );
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editBankCharge = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editBankCharge", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editTax = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editTax", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editSale = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editSale", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editAsset = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editAsset", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};
export const editAssetValue = async (paymentData) => {
  try {
    const response = await axiosInstance.post("/editAssetValue", paymentData);
    return response.data;
  } catch (error) {
    console.log("Error in payment save api", error);
    throw error;
  }
};

export const deleteOtherIncome = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteOtherIncome", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteOtherIncome", error);
  }
};
export const deleteDeposit = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteDeposit", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteDeposit", error);
  }
};
export const deletePrepaidExpense = async (payments) => {
  try {
    const response = await axiosInstance.post(
      "/deletePrepaidExpense",
      payments,
    );
    return response.data;
  } catch (error) {
    console.log("Error in deletePrepaidExpense", error);
  }
};
export const deletePayable = async (payments) => {
  try {
    const response = await axiosInstance.post("/deletePayable", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deletePayable", error);
  }
};
export const deleteCashAsset = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteCashAsset", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteCashAsset", error);
  }
};
export const deleteCapital = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteCapital", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteCapital", error);
  }
};
export const deleteGratuity = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteGratuity", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteGratuity", error);
  }
};
export const deleteProfitAndLossWithdrawal = async (payments) => {
  try {
    const response = await axiosInstance.post(
      "/deleteProfitAndLossWithdrawal",
      payments,
    );
    return response.data;
  } catch (error) {
    console.log("Error in deleteProfitAndLossWithdrawal", error);
  }
};

export const deleteBankCharge = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteBankCharge", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteOtherIncome", error);
  }
};
export const deleteTax = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteTax", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteOtherIncome", error);
  }
};
export const deleteAsset = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteAsset", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteOtherIncome", error);
  }
};
export const deleteAssetValue = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteAssetValue", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteOtherIncome", error);
  }
};
export const deleteSale = async (payments) => {
  try {
    const response = await axiosInstance.post("/deleteSale", payments);
    return response.data;
  } catch (error) {
    console.log("Error in deleteOtherIncome", error);
  }
};
